var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8341 4.78084L19.7069 4.65268M18.8324 3.77155L18.0532 2.98654H9.64189L3.69513 8.97821V17.4531L5.15002 18.9189M8.0439 21.8347L9.64189 23.4447H18.0532L24 17.4531V8.97821L20.7086 5.66197M6.79571 20.5771L6.39025 20.1685M13.5375 7.20795L15.0798 10.6203L18.729 11.0609L16.0259 13.6081L16.7414 17.2929L13.5296 15.4585L10.3177 17.2929L11.0332 13.6081L8.33011 11.0609L11.9793 10.6203L13.5216 7.20795H13.5375ZM4.80021 20.505L1 21.338L4.80021 22.1711L5.62703 26L6.45385 22.1711L10.2541 21.338L6.45385 20.505L5.62703 16.6761L4.80021 20.505ZM19.8102 3.55527L17.2741 4.11599L19.8102 4.67671L20.3667 7.23198L20.9233 4.67671L23.4594 4.11599L20.9233 3.55527L20.3667 1L19.8102 3.55527ZM13.8476 5.56584C9.84065 5.56584 6.58901 8.84204 6.58901 12.8792C6.58901 16.9164 9.84065 20.1926 13.8476 20.1926C17.8545 20.1926 21.1061 16.9164 21.1061 12.8792C21.1061 8.84204 17.8545 5.56584 13.8476 5.56584Z",
    stroke: "white",
    strokeOpacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatino);
export default __webpack_public_path__ + "static/media/platino.e32c0ff6afdb733c915a4db6ef85e15f.svg";
export { ForwardRef as ReactComponent };